import { FuelTransactionsProcessingHold } from "../FuelTransactionsProcessingHold";
import { FuelTransactionsProcessingReady } from "../FuelTransactionsProcessingReady";
import { Label, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutFuelTransactionsProcessing extends Layout {
    labelPageTitle: Label;
    layoutFuelTransactionsHold: FuelTransactionsProcessingHold;
    layoutReadyToProcess: FuelTransactionsProcessingReady;
    tabHold: Tab;
    tabReady: Tab;
    tabsetFuelTransactions: Tabset;
}
